function initializeDropdownMenu() {
	
    const dropdownToggles = document.querySelectorAll('.dropdown-toggle');
    const navbarToggler = document.querySelector('.navbar-toggler');
    const body = document.body;

    // Toggle the dropdowns
    dropdownToggles.forEach(toggle => {
        toggle.addEventListener('click', function (event) {
            event.preventDefault(); // Prevent default anchor behavior

            const parentNavItem = toggle.closest('.nav-item'); // Get the parent .nav-item

            // If this dropdown is already open, close it
            if (parentNavItem.classList.contains('show')) {
                parentNavItem.classList.remove('show');
                return;
            }

            // Close all other open dropdowns
            document.querySelectorAll('.nav-item.show').forEach(item => {
                item.classList.remove('show');
            });

            // Add 'show' class to the clicked dropdown's parent .nav-item
            parentNavItem.classList.add('show');
        });
    });

    // Handle the navbar-toggler click
    navbarToggler.addEventListener('click', function () {
        const navbarResponsive = document.querySelector('#navbarResponsive');

        // Toggle the 'no-scroll' class on the body when the navbar is expanded/collapsed
        body.classList.toggle('no-scroll', !navbarResponsive.classList.contains('show'));
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', function (event) {
        if (!event.target.closest('.nav-item')) {
            document.querySelectorAll('.nav-item.show').forEach(item => {
                item.classList.remove('show');
            });
        }
    });
}

// Export the function
export { initializeDropdownMenu };
